<style lang="scss" scoped>
@import "./login.scss";

.connect-btn-container {
    margin-left: 0;
    list-style: none;
    padding-bottom: 15px;
}
.connect-btn-container-common {
    text-align: center;
}
.connect-btn-container li {
    padding: 5px;
    display: inline;
}
.login-type-title {
    padding-top: 15px;
    font-size: 18px;
    font-weight: bold;
}
.login-button-content {
    display: flex;
    justify-content: space-between;
}
.login-container {
    text-align: center;
    margin: 15px 0;
}
.phone-login {
    .tip {
        margin-top: 10px;
    }
    .phone {
        // color: #fff;
        text-align: center;
        margin-top: 15px;
        font-size: 25px;
        font-weight: bold;
    }
    .time-count {
        // margin: 5px 0;
        text-align: right;
        // color: #ed4014;
    }
    .button-content {
        text-align: right;
    }
    .tip-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .resend {
        margin-right: 15px;
    }
}
.languageitem .ivu-radio-wrapper {
    padding: 0px !important;
}
.social-login {
    border-top: 1px solid #ccc;
    margin-top: 20px;
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;
    &-title {
        padding-right: 20px;
    }
    &-list {
        display: flex;
    }
    &-item {
        margin-right: 15px;
        line-height: 32px;
        &:last-child {
            margin-right: 0;
        }
    }
}
</style>
<template>
    <div class="login-bg">
        <div v-if="auto">
            <Spin
                size="large"
                fix
                style="
                    background-color: rgba(255, 255, 255, 0.6);
                    font-size: 14px;
                "
            >
                <span
                    class="ivu-spin-dot"
                    style="display: block; margin: auto"
                ></span>
                {{ loadingText }}
            </Spin>
        </div>
        <!-- 未输入密码 -->
        <div v-if="loginProcessStatus === 1" class="login-content">
            <Tabs :value="loginType">
                <!-- 普通登录 -->
                <TabPane
                    :label="
                        $t('port.login.password_login', {
                            defaultValue: '密码登录',
                        })
                    "
                    name="0"
                >
                    <div @keyup.enter="submitForm">
                        <!-- <div> -->
                        <h3 class="login-title">
                            {{ $t("port.login.title") }}
                        </h3>
                        <Form
                            ref="normalLoginForm"
                            :rules="rules"
                            :model="formData"
                            @submit.native.prevent="
                                () => {
                                    return false;
                                }
                            "
                        >
                            <!-- 用户名 -->
                            <FormItem prop="username" class="login-item">
                                <Input
                                    v-model="formData.username"
                                    :placeholder="$t('port.login.username')"
                                >
                                    <span slot="prepend">
                                        <Icon
                                            :size="16"
                                            type="md-person"
                                        ></Icon>
                                    </span>
                                </Input>
                            </FormItem>
                            <!-- 密码 -->
                            <FormItem prop="password" class="login-item">
                                <Input
                                    v-model="formData.password"
                                    type="password"
                                    :placeholder="$t('port.login.password')"
                                >
                                    <span slot="prepend">
                                        <Icon :size="16" type="md-lock"></Icon>
                                    </span>
                                </Input>
                            </FormItem>
                            <!-- <div style="margin-top:-5px;font-size:14px;color:#fff">Language / 语言 :</div> -->
                            <FormItem class="login-item languageitem">
                                <RadioGroup v-model="valueLang">
                                    <Radio label="zh-CN">简体中文</Radio>
                                    <Radio label="en">English</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem class="login-item clearfix color-fff">
                                <div class="login-button-content">
                                    <div>
                                        <Checkbox
                                            v-model="formData.save"
                                            class="vertical-middle"
                                            >{{
                                                $t("port.login.save")
                                            }}</Checkbox
                                        >
                                    </div>
                                    <div class="login-button-group">
                                        <Button
                                            type="primary"
                                            @click="submitForm"
                                        >
                                            {{ $t("port.login.login") }}&nbsp;
                                            <Icon type="md-arrow-forward" />
                                        </Button>
                                    </div>
                                </div>
                            </FormItem>
                            <!-- <div class="margin-bottom-10">
                                <router-link to="/reset">{{
                                    $t("port.login.forget")
                                }}</router-link>
                                <router-link to="/register" class="margin-left-10">
                                注册
                                </router-link>
                            </div> -->
                            <div class="social-login" v-if="showSocialLogin">
                                <div class="social-login-title">
                                    {{ $t("port.login.social_login") }}
                                </div>
                                <ul class="social-login-list">
                                    <li
                                        class="social-login-item"
                                        v-for="item in socialLoginButtons"
                                        :key="item.id"
                                    >
                                        <Button
                                            @click="socialLogin(item.id)"
                                            :type="item.button"
                                            >{{
                                                $t(`port.login.${item.label}`)
                                            }}</Button
                                        >
                                    </li>
                                </ul>
                            </div>
                        </Form>
                    </div>
                </TabPane>
                <!-- 免密登录 -->
                <TabPane
                    :label="
                        $t('port.login.vercode_login', {
                            defaultValue: '验证码登录',
                        })
                    "
                    name="1"
                >
                    <CompPhoneLogin
                        :loginCheckType="0"
                        @on-commit="submitPhoneLogin"
                    ></CompPhoneLogin>
                </TabPane>
            </Tabs>
        </div>
        <!-- MFA | IP地址手机验证 -->
        <div v-else-if="loginProcessStatus === 2" class="login-content">
            <!-- MFA-手机验证 -->
            <div v-if="loginCheckType === 2">
                <CompPhoneLogin
                    ref="mfaPhoneLogin"
                    :loginCheckList="loginCheckList"
                    :loginCheckType="2"
                    :phone="phone"
                    :sendImmediately="sendImmediately"
                    @on-commit="submitPhoneLogin"
                    @on-switch="switchCheckType"
                ></CompPhoneLogin>
            </div>
            <!-- IP地址手机验证号 -->
            <div v-else-if="loginCheckType === 1">
                <CompPhoneLogin
                    :loginCheckType="1"
                    :phone="phone"
                    @on-commit="submitPhoneLogin"
                ></CompPhoneLogin>
            </div>
            <!-- MFA-验证器登录 -->
            <div v-else-if="loginCheckType === 3">
                <CompAuthLogin
                    :loginCheckList="loginCheckList"
                    @on-commit="submitAuthLogin"
                    @on-switch="switchCheckType"
                ></CompAuthLogin>
            </div>
        </div>
        <!-- 社交登录 -->
        <div v-else-if="loginProcessStatus === 3" class="login-content">
            <h3 class="login-title">
                <Icon
                    style="font-size: 25px; cursor: pointer"
                    type="ios-arrow-back"
                    @click="backToNormalLogin"
                />
                <span style="margin-left: 15px">{{ loginSocialName }}</span>
            </h3>
            <div
                class="login-container"
                v-show="showConnectAuthCode"
                ref="login_container"
                id="login_container"
            ></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import util from "../utils/index";
import Cookies from "js-cookie";
import {
    HttpLogin,
    HttpSocialAuthCallback,
    HttpSocialAuthRender,
    SOCIAL_VENDOR_DINGTALK,
    SOCIAL_VENDOR_WECHAT,
} from "@mods/service/base";
import {
    HttpCheckPassweak,
    HttpSendMFACode,
    HttpVCodeLogin,
    HttpCheckPasswordSecurity,
} from "@/service/port";
import CompPhoneLogin from "./phoneLogin";
import CompAuthLogin from "./authLogin";
import BrowserType from "@mods/utils/browser-type";
import {
    SOCIAL_VENDOR_QLINYUN,
    SOCIAL_VENDOR_QLINYUNDEV,
} from "@mods/service/base";
export default {
    components: {
        CompPhoneLogin,
        CompAuthLogin,
    },
    data() {
        const connectUrlPrefix =
            window.location.protocol + "//" + window.location.host;
        const browserType = BrowserType();
        return {
            // 登录状态 1 未输入密码 2 已输入密码，要求验证 3 社交登录
            loginProcessStatus: 1,
            // 登录类型 0 标准 1 免密登录
            loginType: 0,
            // 登录验证 0 不需验证 1 VCODE-IP地址变化需要验证手机号 2 MFA-SMS-验证手机号 3 MFA-authorizator-验证器
            loginCheckType: 0,
            loginSocialName: "三方登录",
            // MFA验证时可切换的验证方式
            loginCheckList: [],
            sendImmediately: true,
            phone: "",
            browserType: browserType,
            connectUrlPrefix: connectUrlPrefix,
            formData: {
                save: true,
                password: "",
                username: "",
            },
            loadingText: this.$t("port.login.login_now", {
                defaultValue: "正在登陆中,请稍后...",
            }),
            auto: true,
            showConnectAuthCode: false,
            connectAuthRenderData: {},
            service: "",
            // 是否展示社交登录
            showSocialLogin: util.checkSocialLogin(window.location.hostname),
            // 社交登录的按钮数组
            socialLoginButtons: util.getAvailableSourcesByHost(
                window.location.hostname
            ),
        };
    },
    computed: {
        ...mapState(["lang", "loginData"]),
        valueLang: {
            get() {
                return this.lang;
            },
            async set(lang) {
                this.setLang(lang);
                await this.$store
                    .dispatch("actionGetLangList", { lang })
                    .then((cb) => cb(this.$i18n));
                this.$set(
                    this,
                    "loadingText",
                    this.$t("port.login.login_now", {
                        defaultValue: "正在登陆中,请稍后...",
                    })
                );
            },
        },
        rules() {
            return {
                username: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                ],
                password: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                ],
            };
        },
    },
    async created() {
        let hashToken = util.getHashToken(window.location.href);
        let loginFlag = false;
        if (hashToken) {
            await this.login({
                token: hashToken,
            })
                .then(() => {
                    this.cleanHashToken();
                    this.handleCheckPassweak();
                    loginFlag = true;
                })
                .catch((err) => {
                    this.cleanHashToken();
                    this.auto = false;
                    this.$Message.error({
                        content: err.message,
                        duration: 7,
                    });
                });
            if (loginFlag) return;
        }
        if (this.$route.query.connect) {
            this.auto = true;
            let authCallbackParams = {};
            if (this.$route.query.service) {
                authCallbackParams.service = this.$route.query.service;
            }
            if (!!Cookies.get("token")) {
                authCallbackParams.bindToken = Cookies.get("token");
            }
            if (this.$route.query.code) {
                authCallbackParams.code = this.$route.query.code;
            }
            if (this.$route.query.state) {
                authCallbackParams.state = this.$route.query.state;
            }
            if (this.$route.query.auth_code) {
                authCallbackParams.auth_code = this.$route.query.auth_code;
            }
            if (this.$route.query.authorization_code) {
                authCallbackParams.authorization_code =
                    this.$route.query.authorization_code;
            }
            if (this.$route.query.oauth_token) {
                authCallbackParams.oauth_token = this.$route.query.oauth_token;
            }
            if (this.$route.query.oauth_verifier) {
                authCallbackParams.oauth_verifier =
                    this.$route.query.oauth_verifier;
            }
            if (this.$route.query.tmp_auth_code) {
                authCallbackParams.tmp_auth_code =
                    this.$route.query.tmp_auth_code;
            }
            if (this.$route.query.loginTmpCode) {
                authCallbackParams.loginTmpCode =
                    this.$route.query.loginTmpCode;
            }

            let tempPam = this.$route.query.connect;

            switch (tempPam) {
                case SOCIAL_VENDOR_DINGTALK:
                case SOCIAL_VENDOR_QLINYUN:
                case SOCIAL_VENDOR_QLINYUNDEV:
                    {
                        // console.log("authCallbackParams", authCallbackParams);
                        let socialAuthCallbackResult = {};
                        try {
                            socialAuthCallbackResult =
                                await HttpSocialAuthCallback(
                                    this.$route.query.connect,
                                    window.location.host,
                                    authCallbackParams
                                );
                        } catch (err) {
                            socialAuthCallbackResult = {
                                message: err.message,
                            };
                        }
                        // console.log("socialAuthCallbackResult",socialAuthCallbackResult);
                        if (socialAuthCallbackResult.code === 200) {
                            if (
                                socialAuthCallbackResult.data.uid &&
                                socialAuthCallbackResult.data.uid > 0 &&
                                socialAuthCallbackResult.data.token
                            ) {
                                // console.log("socialAuthCallbackResult.data uid,token",socialAuthCallbackResult.data.uid,socialAuthCallbackResult.data.token);
                                // this.$Message.info({content: `当前社交用户已绑定用户id为 ${socialAuthCallbackResult.data.uid}`,duration: 7});
                                this.login({
                                    token: socialAuthCallbackResult.data.token,
                                })
                                    .then(this.handleCheckPassweak)
                                    .catch((err) => {
                                        this.auto = false;
                                        this.$Message.error({
                                            content: err.message,
                                            duration: 7,
                                        });
                                    });
                            } else {
                                this.auto = false;
                                this.$Message.warning({
                                    content:
                                    this.$t("global.common.account_fill_error", {
                                        defaultValue: "当前社交账户尚未绑定平台账户请先用用户名密码登录后在用户资料中绑定后使用",
                                    }),
                                    duration: 7,
                                });
                            }
                        } else {
                            this.auto = false;
                            this.$Message.error({
                                content: socialAuthCallbackResult.message,
                                duration: 7,
                            });
                        }
                    }
                    break;
                default:
                    {
                        this.auto = false;
                        this.$Message.error("尚未完工，敬请期待");
                    }
                    break;
            }
        } else {
            this.formData = { ...this.loginData, save: true };
            if (!!Cookies.get("token")) {
                this.submitLogin();
            } else {
                this.auto = false;
                this.setLoginData({});
            }
            this.handleUserBrowser();
        }
    },
    methods: {
        ...mapMutations(["setLoginData", "setLang"]),
        /**
         * 清除地址栏hash
         */
        cleanHashToken() {
            // console.log(window.location.href.substring(0, window.location.href.indexOf('#token=')));
            // window.location.href = window.location.href.substring(0, window.location.href.indexOf('#token='))
            this.$router.hash = "";
            window.location.hash = "";
        },
        /**
         * 返回正常登录
         */
        backToNormalLogin() {
            this.loginProcessStatus = 1;
            this.loginType = 0;
        },
        /**
         * 切换验证方式
         */
        switchCheckType() {
            // MFA短信切换为验证器
            if (this.loginCheckType === 2) this.loginCheckType = 3;
            // MFA验证器切换为手机
            else {
                this.loginCheckType = 2;
                // 不要立即发送验证码
                this.sendImmediately = false;
            }
        },
        /**
         * 更改验证方式
         */
        changeValidType() {
            if (this.loginType === 1) this.loginType = 2;
            else this.loginType = 1;
        },
        /**
         * 验证码数据格式化
         * @param data 登录数据
         */
        submitAuthLogin(data) {
            let requestData = {
                via: 1,
                verify_token: data.vCode,
                idlabel: this.phone,
            };
            this.submitVCodeLogin(requestData);
        },
        /**
         * 手机登录数据格式化
         */
        submitPhoneLogin(data) {
            let requestData = {
                via: 2,
                idlabel: data.phone,
                verify_token: data.vCode,
            };
            this.submitVCodeLogin(requestData);
        },
        /**
         * 手机和验证码登录
         * @param data 登录数据
         */
        submitVCodeLogin(data) {
            HttpVCodeLogin({
                ...data,
                service: this.service,
            }).then(
                (res) => {
                    Cookies.set("token", res.data.token, {
                        expires: 14,
                        path: "/",
                        domain: global.DOMAIN,
                    });
                    this.handleCheckPassweak(this.service);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async login(data = {}) {
            Cookies.remove("token", { path: "/", domain: global.DOMAIN });
            let service = this.$route.query.service || "",
                hash = this.$route.hash;
            if (service) service = service + hash;
            const res = await HttpLogin(data).catch((err) => {
                this.$VMessage.error(err.message);
            });
            if (res) {
                // 无token
                if (!res.data.token) {
                    // MFA方式开启登录
                    if (res.data.next === "MFA") {
                        this.loginCheckList = res.data.channels;
                        switch (res.data.via) {
                            // MFA验证器
                            case "authorizator":
                                {
                                    // 支持手机验证
                                    let other = res.data.channels.filter(
                                        (item) => {
                                            return item === "sms";
                                        }
                                    );
                                    if (other.length > 0) this.hasSwitch = true;
                                    // this.loginType = 2;
                                    // MFA登录 SMS验证
                                    this.loginProcessStatus = 2;
                                    this.loginCheckType = 3;
                                    this.phone = res.data.idlabel;
                                    this.auto = false;
                                    this.service = service;
                                    return {
                                        flag: "MFA",
                                        service: service,
                                    };
                                }
                                break;
                            // MFA短信
                            case "sms": {
                                // 支持验证器验证
                                let other = res.data.channels.filter((item) => {
                                    return item === "authorizator";
                                });
                                if (other.length > 0) this.hasSwitch = true;
                                // MFA登录 SMS验证
                                this.loginProcessStatus = 2;
                                this.loginCheckType = 2;
                                this.phone = res.data.idlabel;
                                // this.phoneLogin.phoneNumber = res.data.idlabel;
                                // this.loginType = 1;
                                // await this.resendCode();
                                this.auto = false;
                                this.service = service;
                                return {
                                    flag: "MFA",
                                    service: service,
                                };
                                break;
                            }
                        }
                    } else if (res.data.next === "VCODE") {
                        // MFA登录 SMS验证
                        this.loginProcessStatus = 2;
                        this.loginCheckType = 1;
                        this.phone = res.data.idlabel;
                        this.auto = false;
                        this.service = service;
                        return {
                            flag: "MFA",
                            service: service,
                        };
                    }
                } else {
                    // console.log("执行了正常登录");
                    Cookies.set("token", res.data.token, {
                        expires: 14,
                        path: "/",
                        domain: global.DOMAIN,
                    });
                    return {
                        flag: true,
                        service: service,
                    };
                }
            }
        },
        async handleCheckPassweak(service) {
            // console.log('handleCheckPassweak.service',service);
            // console.log('即将跳转', service)
            if (service && service.service != undefined) {
                service = service.service;
            }
            // console.log('最终的service', service);
            const successSkip = (service) => {
                return service
                    ? setTimeout(() => {
                          location.href = service;
                      }, 1600)
                    : this.$router.push({ name: "panel" });
            };
            const failSkip = (type = 1) => {
                let text = this.$t("port.login.low_password_security_expired", {
                    defaultValue: "密码已过期，请重新设定",
                });
                // 弱密码
                if (type == 2) {
                    text = this.$t("port.login.low_password_security_weak", {
                        defaultValue: "当前密码属于弱密码，请重新设定",
                    });
                }
                this.loadingText = text;
                setTimeout(() => {
                    location.href = this.handleHostname(
                        `https://${global.envPrefix}port.onepinnovate.com/home/password`
                    );
                }, 2000);
            };
            // 设置token以防出错
            global.AUTH_TOKEN = Cookies.get("token");
            localStorage.TIMESSTAMP = Date.now();
            // const weakRes = await HttpCheckPassweak().catch((err) => {
            //     this.$VMessage.error(err.message);
            // });
            // if (weakRes.data.isWeak) {
            //     return failSkip();
            // }

            // 每次强制检查
            const securityRes = await HttpCheckPasswordSecurity()
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    this.$VMesage.error(err.message);
                });
            // 判断密码是否过期
            if (
                securityRes.orgRoleLabel == "service" &&
                securityRes.passwordIsExpired == true
            ) {
                return failSkip(1);
            }
            // 是否弱密码
            if (securityRes.passwordIsWeak == true) {
                return failSkip(2);
            }
            // if ((localStorage.TIMESSTAMP || 0) < Date.now() - 1728000000) {
            //     localStorage.TIMESSTAMP = Date.now();
            //     const res = await HttpCheckPassweak().catch((err) => {
            //         successSkip(service);
            //     });
            //     return res.data.isWeak ? failSkip() : successSkip(service);
            // }
            successSkip(service);
        },
        submitLogin() {
            const formData = this.formData;
            this.auto = true;
            this.setLoginData(formData.save ? formData : {});
            this.login(formData)
                .then((resObj) => {
                    // 未知账户报错
                    if (!resObj) return (this.auto = false);
                    // MFA方式登录
                    if (resObj.flag === "MFA") {
                    } else {
                        this.handleCheckPassweak(resObj.service);
                    }
                })
                .catch((err) => {
                    this.auto = false;
                    this.$Message.error(err.message);
                });
        },
        async submitForm() {
            await this.$refs.normalLoginForm.validate((valid) => {
                if (valid) this.submitLogin();
            });
            return false;
        },
        async socialLogin(source) {
            let vm = this;
            this.loginProcessStatus = 3;
            this.loginSocialName = this.$t(`port.login.${source}`);
            if (
                source === SOCIAL_VENDOR_DINGTALK ||
                source === SOCIAL_VENDOR_QLINYUN ||
                source === SOCIAL_VENDOR_QLINYUNDEV
            ) {
                // ok
            } else {
                return vm.$Message.error("尚未完工，敬请期待");
            }
            if (source) {
                this.auto = true;
                let service = this.$route.query.service || "",
                    hash = this.$route.hash;
                if (service) service = service + hash;
                const callbackUrl = `${this.connectUrlPrefix}/login?connect=${source}&service=${service}`;
                // console.log(callbackUrl);
                if (
                    source === SOCIAL_VENDOR_DINGTALK ||
                    source === SOCIAL_VENDOR_QLINYUN ||
                    source === SOCIAL_VENDOR_QLINYUNDEV
                ) {
                    // console.log('callbackUrl',callbackUrl);
                    try {
                        vm.connectAuthRenderData = await HttpSocialAuthRender(
                            source,
                            window.location.host,
                            encodeURIComponent(callbackUrl)
                        );
                    } catch (err) {
                        vm.$Message.error({
                            content: err.message,
                            duration: 7,
                        });
                        this.auto = false;
                        return false;
                    }

                    // console.log('connectAuthRenderData',vm.connectAuthRenderData);
                    // console.log('connectAuthRenderData.redirectUri',vm.connectAuthRenderData.data.redirectUri);
                    if (vm.connectAuthRenderData.code === 200) {
                        if (source === SOCIAL_VENDOR_DINGTALK) {
                            if (
                                (vm.browserType.platform &&
                                    vm.browserType.platform === "mobile") ||
                                (vm.browserType.shell &&
                                    vm.browserType.shell ===
                                        SOCIAL_VENDOR_DINGTALK)
                            ) {
                                let url = encodeURIComponent(
                                    vm.connectAuthRenderData.data.redirectUri
                                );
                                let scope =
                                    vm.browserType.shell &&
                                    vm.browserType.shell ==
                                        SOCIAL_VENDOR_DINGTALK
                                        ? "snsapi_auth"
                                        : "snsapi_login";
                                let goto =
                                    `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${vm.connectAuthRenderData.data.clientId}&response_type=code&scope=${scope}&state=${vm.connectAuthRenderData.data.state}&redirect_uri=` +
                                    url;
                                window.location.href = goto;
                                return true;
                            } else {
                                await this.$loadScript(
                                    "https://g.alicdn.com/dingding/dinglogin/0.0.5/ddLogin.js"
                                );
                                this.showConnectAuthCode = true;
                                this.auto = false;
                                vm.$nextTick(() => {
                                    // console.log('vm.connectAuthRenderData.data.redirectUri ',vm.connectAuthRenderData.data.redirectUri);
                                    let url = encodeURIComponent(
                                        vm.connectAuthRenderData.data
                                            .redirectUri
                                    );
                                    // console.log('nexTick url',url);
                                    let goto = encodeURIComponent(
                                        `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${vm.connectAuthRenderData.data.clientId}&response_type=code&scope=snsapi_login&state=${vm.connectAuthRenderData.data.state}&redirect_uri=` +
                                            url
                                    );
                                    let obj = window.DDLogin({
                                        id: "login_container", //这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
                                        goto: goto, //请参考注释里的方式
                                        style: "border:none;background-color:#FFFFFF;",
                                        width: "270",
                                        height: "300",
                                    });
                                    // 重置扫码登录框的样式，让登录框居中
                                    // let box = document.getElementById('login_container');
                                    // box.querySelector('iframe').style.position = 'absolute';
                                    // box.querySelector('iframe').style.top = '0';
                                    // box.querySelector('iframe').style.bottom = '0';
                                    // box.querySelector('iframe').style.left = '0';
                                    // box.querySelector('iframe').style.right = '0';
                                    // box.querySelector('iframe').style.margin = 'auto';
                                    let handleMessage = function (event) {
                                        let origin = event.origin;
                                        // console.log("origin", event.origin);
                                        if (
                                            origin ==
                                            "https://login.dingtalk.com"
                                        ) {
                                            //判断是否来自ddLogin扫码事件。
                                            let loginTmpCode = event.data;
                                            //获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
                                            // console.log("loginTmpCode", loginTmpCode);
                                            let url = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${vm.connectAuthRenderData.data.clientId}&response_type=code&scope=snsapi_login&state=${vm.connectAuthRenderData.data.state}&redirect_uri=${vm.connectAuthRenderData.data.redirectUri}&loginTmpCode=${loginTmpCode}`;
                                            // console.log('redirect social url',url);
                                            window.location.href = url;
                                            return true;
                                        }
                                    };
                                    if (
                                        typeof window.addEventListener !=
                                        "undefined"
                                    ) {
                                        window.addEventListener(
                                            "message",
                                            handleMessage,
                                            false
                                        );
                                    } else if (
                                        typeof window.attachEvent != "undefined"
                                    ) {
                                        window.attachEvent(
                                            "onmessage",
                                            handleMessage
                                        );
                                    }
                                });
                            }
                        } else if (source === SOCIAL_VENDOR_QLINYUN) {
                            let url = encodeURIComponent(
                                vm.connectAuthRenderData.data.redirectUri
                            );
                            let scope = "";
                            let goto =
                                `https://cas.qlinyun.com/cas/oauth2.0/authorize?client_id=${vm.connectAuthRenderData.data.clientId}&response_type=code&scope=${scope}&state=${vm.connectAuthRenderData.data.state}&redirect_uri=` +
                                url;
                            window.location.href = goto;
                            return true;
                        } else if (source === SOCIAL_VENDOR_QLINYUNDEV) {
                            let url = encodeURIComponent(
                                vm.connectAuthRenderData.data.redirectUri
                            );
                            let scope = "";
                            let goto =
                                `https://cas.back.qlinyun.com:9443/cas/oauth2.0/authorize?client_id=${vm.connectAuthRenderData.data.clientId}&response_type=code&scope=${scope}&state=${vm.connectAuthRenderData.data.state}&redirect_uri=` +
                                url;
                            window.location.href = goto;
                            return true;
                        }
                    } else {
                        vm.$Message.error({
                            content: vm.connectAuthRenderData.message,
                            duration: 7,
                        });
                        return false;
                    }
                } else {
                    vm.$Message.error("尚未完工，敬请期待");
                    this.auto = false;
                    return false;
                }
            }
        },
    },
};
</script>
